import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
export function ImageBreak() {
  return <section className="relative h-[40vh] md:h-[50vh] w-full flex items-center justify-center overflow-hidden" data-id="element-146">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=1920&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed'
    }} data-id="element-147" />
      <div className="absolute inset-0 z-10 bg-black/55" data-id="element-148" />
      <div className="relative z-20 max-w-3xl mx-auto px-6 text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-150">
          <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-white italic leading-relaxed mb-8" data-id="element-151">
            "Every celebration deserves a setting as extraordinary as the love
            it honors."
          </p>
          <Ornament variant="leaf" color="#FFFFFF" opacity={0.5} className="w-24" data-id="element-152" />
        </motion.div>
      </div>
    </section>;
}